var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfindemnityfordoctorsicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 62,
    viewBox: "0 0 73 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8264 22.4814C10.2315 22.4814 8.93872 23.775 8.93872 25.369V59.091C8.93872 60.6859 10.2315 61.9786 11.8264 61.9786H37.3438V22.4805H11.8264V22.4814Z",
    fill: "#FBD099"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7498 59.0901V25.3681C65.7498 23.7732 64.457 22.4805 62.8621 22.4805H37.3447V61.9786H62.8621C64.457 61.9777 65.7498 60.6858 65.7498 59.0901Z",
    fill: "#F9B256"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2466 26.0781C14.6525 26.0781 13.3589 27.3718 13.3589 28.9658V55.3272C13.3589 56.922 14.6517 58.2148 16.2466 58.2148H37.3613V26.0781H16.2466Z",
    fill: "#F0851D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3286 55.3272V28.9658C61.3286 27.3718 60.0358 26.0781 58.4409 26.0781H37.3613V58.2148H58.4409C60.0358 58.2148 61.3286 56.922 61.3286 55.3272Z",
    fill: "#E8721B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4961 12.8896H37.488V10.002H24.497C22.1082 10.002 20.1655 11.9455 20.1655 14.3335V20.3723H21.5681C21.5962 20.3723 21.619 20.3846 21.6454 20.3881C21.6726 20.3846 21.6954 20.3723 21.7227 20.3723H23.0532V14.3335C23.0523 13.5369 23.6996 12.8896 24.4961 12.8896Z",
    fill: "#CCCCCC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8483 20.3711H23.0523H21.7218C21.6946 20.3711 21.6709 20.3834 21.6445 20.3869C21.6182 20.3834 21.5944 20.3711 21.5672 20.3711H20.1647H18.4415C18.0419 20.3711 17.7188 20.6943 17.7188 21.0939C17.7188 21.1141 17.7293 21.1325 17.731 21.1519H20.1655H23.0532H25.5597C25.5615 21.1325 25.5711 21.1141 25.5711 21.0939C25.5711 20.6952 25.2479 20.3711 24.8483 20.3711Z",
    fill: "#B2B2B2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5596 21.1523H17.7301H17.0354V22.4803H26.1814V21.1523H25.5596Z",
    fill: "#F0851D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6899 20.3861C51.7171 20.3826 51.7399 20.3703 51.7672 20.3703H53.1337V14.3315C53.1337 11.9436 51.191 10 48.8022 10H37.4878V12.8877H48.8031C49.5988 12.8877 50.2469 13.5349 50.2469 14.3306V20.3694H51.6135C51.6398 20.3703 51.6635 20.3826 51.6899 20.3861Z",
    fill: "#B2B2B2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8937 20.3711H53.1337H51.7672C51.74 20.3711 51.7163 20.3834 51.6899 20.3869C51.6636 20.3834 51.6399 20.3711 51.6126 20.3711H50.2461H48.487C48.0874 20.3711 47.7642 20.6943 47.7642 21.0939C47.7642 21.1141 47.7747 21.1325 47.7764 21.1519H50.247H53.1346H55.606C55.6078 21.1325 55.6183 21.1141 55.6183 21.0939C55.6165 20.6952 55.2933 20.3711 54.8937 20.3711Z",
    fill: "#999999"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.605 21.1523H47.7755H47.1177V22.4803H56.2628V21.1523H55.605Z",
    fill: "#E8721B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3155 41.5131C47.3155 46.9407 42.9155 51.3398 37.488 51.3398C32.0604 51.3398 27.6604 46.9398 27.6604 41.5131C27.6604 36.0847 32.0604 31.6855 37.488 31.6855C42.9155 31.6847 47.3155 36.0847 47.3155 41.5131Z",
    fill: "#D3362D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2542 35.3164H35.7219V47.7084H39.2542V35.3164Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.684 39.7461H31.292V43.2793H43.684V39.7461Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93962 43.709H3.32764V44.9824H8.93962V43.709Z",
    fill: "#D3362D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.89553 40.957C2.34224 40.957 1.89258 41.4058 1.89258 41.96V44.0212H3.32675H8.93873V43.9518V40.9579H2.89553V40.957Z",
    fill: "#E84C43"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8432 43.7324H8.93872V44.9848H14.8432V43.7324Z",
    fill: "#B71C18"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4563 40.957H8.9397V43.951V44.0204H14.8441H16.4592V41.9591C16.4583 41.4058 16.0104 40.957 15.4563 40.957Z",
    fill: "#D3362D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4503 58.8537V49.7744H8.93965V44.6209L3.32591 44.6191L0.223072 47.1977C0.116805 47.2987 0.0544582 47.4374 0.0237197 47.5876C0.00966776 47.6578 0 47.7308 0 47.8054V61.1811C0 61.6342 0.366227 62.0005 0.819401 62.0005H8.94053V58.8537H2.4503Z",
    fill: "#77A7FB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93955 49.7734H2.4502V58.8527H8.93955V49.7734Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8793 61.1804V47.8056C17.8793 47.7301 17.8671 47.6572 17.8495 47.5878C17.8188 47.4675 17.7643 47.3577 17.6809 47.2743C17.0722 46.6551 14.8389 44.6211 14.8389 44.6211H8.9397V49.7746H15.429V58.8539H8.9397V62.0007H17.0608C17.5122 61.9998 17.8793 61.6336 17.8793 61.1804Z",
    fill: "#4385F5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4281 49.7734H8.93872V58.8527H15.4281V49.7734Z",
    fill: "#CCCCCC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1233 48.1509C15.1233 48.4319 14.895 48.6602 14.6131 48.6602H12.0073C11.7254 48.6602 11.4971 48.4319 11.4971 48.1509C11.4971 47.8698 11.7254 47.6406 12.0073 47.6406H14.6131C14.8959 47.6406 15.1233 47.8698 15.1233 48.1509Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfindemnityfordoctorsicon);
export default __webpack_public_path__ + "static/media/prof indemnity for doctors icon.c2951c3d28a5e0f8ea3831e5b4f8b7f9.svg";
export { ForwardRef as ReactComponent };